import { render, staticRenderFns } from "./NsrItemModuleDataPoints.vue?vue&type=template&id=711acc97"
import script from "./NsrItemModuleDataPoints.vue?vue&type=script&lang=js"
export * from "./NsrItemModuleDataPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports